import Vue from 'vue'
import App from './App.vue'
import router from './main/router'
import store from './main/store'
import 'bootstrap'
import MetaInfo from 'vue-meta-info'
import { Rate, Message, Pagination } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

Vue.use(MetaInfo)

Vue.use(Rate);
Vue.use(Pagination);
Vue.prototype.$message = Message

Vue.config.productionTip = false
for(const i in process.env) {
  window[i] = process.env[i]
}


// document.dispatchEvent(new Event('render-event'))
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
